(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.jmo-catalog__filters[open]').forEach((filters) => {
      if (!filters.contains(event.target)) filters.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.jmo-catalog__filters[open]').forEach((filters) => {
      const restoreFocus = filters.contains(document.activeElement);
      filters.open = false;
      if (restoreFocus) filters.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
